"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentClassGroup = exports.currentClassYear = exports.EPracticeIntensity = exports.classYearGroup = exports.EUserLearningPoint = exports.EUserLearningStatus = exports.EClassYearGroup = exports.dateProductMapping = exports.subscriptionDates = exports.classYears = exports.ETheme = exports.IAccessLevel = void 0;
const luxon_1 = require("luxon");
const Product_1 = require("./Product");
/** TODO:: Change to enum int and rename to EAccessLevel  */
var IAccessLevel;
(function (IAccessLevel) {
    IAccessLevel["SUBSCRIBER"] = "subscriber";
    IAccessLevel["SUPER_ADMIN"] = "superAdmin";
    IAccessLevel["ADMINISTRATOR"] = "administrator";
    IAccessLevel["TUTOR"] = "tutor";
    IAccessLevel["DEMO"] = "demo";
    IAccessLevel["EXPIRED"] = "expired";
    IAccessLevel["EDITOR"] = "editor";
    IAccessLevel["MARKETING"] = "marketing";
})(IAccessLevel = exports.IAccessLevel || (exports.IAccessLevel = {}));
var ETheme;
(function (ETheme) {
    ETheme[ETheme["AUTO"] = 0] = "AUTO";
    ETheme[ETheme["LIGHT"] = 1] = "LIGHT";
    ETheme[ETheme["DARK"] = 2] = "DARK";
})(ETheme = exports.ETheme || (exports.ETheme = {}));
exports.classYears = [
    'Year 1',
    'Year 2',
    'Year 3',
    'Year 4',
    'Year 5',
    'Graduated',
];
exports.subscriptionDates = [
    'qbankSubscriptionEndDate',
    'osceSubscriptionEndDate',
    'bundleSubscriptionEndDate',
    'anatomySubscriptionEndDate',
    'medicalSciencesSubscriptionEndDate',
    'anatomyBundleSubscriptionEndDate',
    'mrcpPart1SubscriptionEndDate',
    'mrcpPart2SubscriptionEndDate',
    'pacesSubscriptionEndDate',
    'msraSubscriptionEndDate',
    'anaestheticsInterviewSubscriptionEndDate',
    'cstInterviewSubscriptionEndDate',
    'imtInterviewSubscriptionEndDate',
    'radiologyInterviewSubscriptionEndDate',
    'paediatricsInterviewSubscriptionEndDate',
    'plab1SubscriptionEndDate',
    'plab2SubscriptionEndDate',
    'ucatSubscriptionEndDate',
    'mrcpVideoSubscriptionEndDate',
];
exports.dateProductMapping = {
    qbankSubscriptionEndDate: Product_1.EProductType.QBANK,
    osceSubscriptionEndDate: Product_1.EProductType.OSCE,
    bundleSubscriptionEndDate: Product_1.EProductType.BUNDLE,
    anatomySubscriptionEndDate: Product_1.EProductType.ANATOMY,
    medicalSciencesSubscriptionEndDate: Product_1.EProductType.MEDICAL_SCIENCES,
    anatomyBundleSubscriptionEndDate: Product_1.EProductType.ANATOMY_BUNDLE,
    mrcpPart1SubscriptionEndDate: Product_1.EProductType.MRCP_PART1,
    mrcpPart2SubscriptionEndDate: Product_1.EProductType.MRCP_PART2,
    mrcpVideoSubscriptionEndDate: Product_1.EProductType.MRCP_VIDEO,
    pacesSubscriptionEndDate: Product_1.EProductType.PACES,
    msraSubscriptionEndDate: Product_1.EProductType.MSRA,
    anaestheticsInterviewSubscriptionEndDate: Product_1.EProductType.INTERVIEW_ANAESTHETICS,
    cstInterviewSubscriptionEndDate: Product_1.EProductType.INTERVIEW_CST,
    imtInterviewSubscriptionEndDate: Product_1.EProductType.INTERVIEW_IMT,
    radiologyInterviewSubscriptionEndDate: Product_1.EProductType.INTERVIEW_RADIOLOGY,
    paediatricsInterviewSubscriptionEndDate: Product_1.EProductType.INTERVIEW_PAEDIATRICS,
    plab1SubscriptionEndDate: Product_1.EProductType.PLAB1,
    plab2SubscriptionEndDate: Product_1.EProductType.PLAB2,
    ucatSubscriptionEndDate: Product_1.EProductType.UCAT,
};
var EClassYearGroup;
(function (EClassYearGroup) {
    EClassYearGroup[EClassYearGroup["PRECLINICAL"] = 0] = "PRECLINICAL";
    EClassYearGroup[EClassYearGroup["CLINICAL"] = 1] = "CLINICAL";
})(EClassYearGroup = exports.EClassYearGroup || (exports.EClassYearGroup = {}));
var EUserLearningStatus;
(function (EUserLearningStatus) {
    EUserLearningStatus[EUserLearningStatus["ALL"] = 0] = "ALL";
    EUserLearningStatus[EUserLearningStatus["UNREAD"] = 1] = "UNREAD";
    EUserLearningStatus[EUserLearningStatus["COMPLETED"] = 2] = "COMPLETED";
    EUserLearningStatus[EUserLearningStatus["REVISING"] = 3] = "REVISING";
    EUserLearningStatus[EUserLearningStatus["URGENT"] = 4] = "URGENT";
})(EUserLearningStatus = exports.EUserLearningStatus || (exports.EUserLearningStatus = {}));
var EUserLearningPoint;
(function (EUserLearningPoint) {
    EUserLearningPoint[EUserLearningPoint["NOT_RELEVANT"] = 0] = "NOT_RELEVANT";
    EUserLearningPoint[EUserLearningPoint["RELEVANT"] = 1] = "RELEVANT";
})(EUserLearningPoint = exports.EUserLearningPoint || (exports.EUserLearningPoint = {}));
exports.classYearGroup = {
    'Year 1': EClassYearGroup.PRECLINICAL,
    'Year 2': EClassYearGroup.PRECLINICAL,
    'Year 3': EClassYearGroup.CLINICAL,
    'Year 4': EClassYearGroup.CLINICAL,
    'Year 5': EClassYearGroup.CLINICAL,
    Graduated: EClassYearGroup.CLINICAL,
    PhD: EClassYearGroup.CLINICAL,
    BSc: EClassYearGroup.PRECLINICAL,
    MSc: EClassYearGroup.CLINICAL,
    'Beta Tester': EClassYearGroup.CLINICAL,
};
var EPracticeIntensity;
(function (EPracticeIntensity) {
    EPracticeIntensity[EPracticeIntensity["NONE"] = 0] = "NONE";
    EPracticeIntensity[EPracticeIntensity["LOW"] = 1] = "LOW";
    EPracticeIntensity[EPracticeIntensity["MED"] = 2] = "MED";
    EPracticeIntensity[EPracticeIntensity["HIGH"] = 3] = "HIGH";
})(EPracticeIntensity = exports.EPracticeIntensity || (exports.EPracticeIntensity = {}));
function currentClassYear(createdAtUnix, classYear, compareUnix = luxon_1.DateTime.now().toUnixInteger()) {
    if (createdAtUnix === 0) {
        throw new Error('createdAt not given in Unix');
    }
    if (!createdAtUnix) {
        return classYear;
    }
    const lastClassYearIdx = exports.classYears.length - 1;
    const classYearsIdx = exports.classYears.findIndex((x) => x === classYear);
    if (classYearsIdx === -1) {
        return exports.classYears[lastClassYearIdx];
    }
    const compareDT = luxon_1.DateTime.fromSeconds(compareUnix);
    const createdAtDT = luxon_1.DateTime.fromSeconds(createdAtUnix);
    if (createdAtDT.year > compareDT.year) {
        throw new Error('createdAt not given in Unix');
    }
    let yearsAdded = compareDT.year - createdAtDT.year;
    let createdAtAcademicDT = luxon_1.DateTime.local(createdAtDT.year, 8, 1);
    if (createdAtDT < createdAtAcademicDT) {
        createdAtAcademicDT = createdAtAcademicDT.minus({ year: 1 });
    }
    const compareAcademicDT = luxon_1.DateTime.local(compareDT.year, 8, 1);
    if (compareDT > compareAcademicDT) {
        yearsAdded++;
    }
    const newClassYearIdx = classYearsIdx + yearsAdded;
    return newClassYearIdx > lastClassYearIdx
        ? exports.classYears[lastClassYearIdx]
        : exports.classYears[newClassYearIdx];
}
exports.currentClassYear = currentClassYear;
function currentClassGroup(createdAtUnix, classYear) {
    const currentClass = currentClassYear(createdAtUnix, classYear);
    if (!exports.classYearGroup.hasOwnProperty(currentClass)) {
        return EClassYearGroup.CLINICAL;
    }
    return exports.classYearGroup[currentClass];
}
exports.currentClassGroup = currentClassGroup;
